import { createAction, props } from '@ngrx/store';
import { UserProfile } from './user-profile.state';
import { IChangePassword } from '../type/user-profile.type';

export const loadUserProfile = createAction('[UserProfile] Load');

export const loadUserProfileSuccess = createAction(
  '[UserProfile] Load Success',
  props<{ profile: UserProfile }>()
);

export const loadUserProfileFailure = createAction(
  '[UserProfile] Load Failure',
  props<{ error: string }>()
);

export const clearUserProfile = createAction('[UserProfile] Clear');

export const updateUserProfileWithRole = createAction(
  '[UserProfile] Update With Role',
  props<{
    roleUserId: string;
    roleId: string;
    roleName: string;
    role: string;
    firstName?: string;
    lastName?: string;
  }>()
);

export const changePasswordRequested = createAction(
  '[UserProfile] Change Password Requested',
  props<{ payload: IChangePassword }>()
);

export const changePasswordSuccess = createAction(
  '[UserProfile] Change Password Success'
);

export const changePasswordFailure = createAction(
  '[UserProfile] Change Password Failure',
  props<{ error: string }>()
);

export const clearChangePasswordStatus = createAction(
  '[UserProfile] Clear Change Password Status'
);
